import { InfoCircleTwoTone } from "@ant-design/icons";
import {
  Box,
  Divider,
  Flex,
  Stack,
  TextButton,
  Typography,
} from "@strapi/design-system";
import { Button, Form, Input, Modal, Radio, Space, Tooltip, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { register } from "../util/API";
import DegreeSelect from "./degreeSelect";
import { isValidEmail } from "../util/helper";

const SignUp = ({ lng = "vi" }) => {
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();
  const tailLayout = {
    wrapperCol: { span: 16 },
  };

  const [modal, contextHolder] = Modal.useModal();

  const [data, setData] = useState({
    username: "",
    email: "",
    password: "",
    gender: "male",
    nominator: {
      is_org: false,
      gender: "male",
      name: "",
      address: "",
      phone: "",
      degree: "",
      representative_email: null,
      representative_phone: null,
      representative_name: null,
      specialization: "",
      working_unit: "",
      address_working_unit: "",
      homepage_working_unit: "",
      phone_working_unit: "",
      is_org_str: "0",
      degree: "",
    },
  });

  let candidateData = {
    email: "",
    password: "",
    self_registration: true,
    gender: "male",
    nominatee: {
      name: "",
      address: "",
      phone: "",
      degree: "",
      representative_email: null,
      representative_phone: null,
      representative_name: null,
      specialization: "",
      working_unit: "",
      gender: "male",
      address_working_unit: "",
      homepage_working_unit: "",
      phone_working_unit: "",
      degree: "",
    },
  };

  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isPreSignup, setIsPreSignup] = useState(true);

  useEffect(() => {
    onLoggedin();
  }, []);

  useEffect(() => {
    if (lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng]);

  useEffect(() => {
    const is_org = searchParams.get("is_org");
    handleSetIsOrg(is_org);

    if (is_org) setIsPreSignup(false);
  }, [searchParams]);

  const onLoggedin = () => {
    const token = localStorage.getItem("token");
    if (token) {
      if (lng === "en") navigate(`/nomination/profile`);
      else navigate(`/nomination/ho-so`);
    }
  };

  const handleSubmit = async () => {
    if (data.nominator.is_org_str !== "2") {
      try {
        const response = await register(data);

        if (response.status === 200) {
          handleRegisterSuccess();
        }
      } catch (error) {}
    } else {
      //* Self-elected
      candidateData.email = data.email;
      candidateData.password = data.password;
      candidateData.nominatee.name = data.nominator.name;
      candidateData.nominatee.degree = data.nominator.degree;
      candidateData.nominatee.gender = data.nominator.gender;

      const response = await register(candidateData);

      if (response.status === 200) {
        handleRegisterSuccess();
        return;
      }
    }
  };

  //#region Handle update info
  const handleSetEmail = (email) => {
    setData({ ...data, email, username: email });
  };

  const handleSetPassword = (password) => {
    setData({ ...data, password });
  };

  const handleSetIsOrg = (is_org_str) => {
    let is_org = false;
    if (is_org_str === "1") is_org = true;
    else is_org = false;

    setData({ ...data, nominator: { ...data.nominator, is_org_str, is_org } });
  };

  const handleSetName = (name) => {
    setData({ ...data, nominator: { ...data.nominator, name } });
  };

  const handleSetPhone = (phone) => {
    const formattedPhoneNumber = phone.replace(/[^0-9+\-().\s]/g, "");
    setData({
      ...data,
      nominator: { ...data.nominator, phone: formattedPhoneNumber },
    });
  };

  const handleSetDegree = (degree) => {
    setData({ ...data, nominator: { ...data.nominator, degree } });
  };

  const onChangePronouns = (value) => {
    setData({ ...data, nominator: { ...data.nominator, gender: value.target.value } });
  };
  //#endregion

  const handleLoginLink = (state = null) => {
    if (lng === "en") navigate("/nomination/login", {state});
    else navigate("/nomination/dang-nhap", {state});
  };

  const handleForgotPassword = () => {
    if (lng === "en") navigate("/nomination/forgot-password");
    else navigate("/nomination/quen-mat-khau");
  };

  const handleNextStep = () => {
    if (
      data.nominator.is_org_str === null ||
      data.nominator.is_org_str === ""
    ) {
      Modal.error({
        title: "Lỗi",
        content: t("str_require_nomination_role"),
      });
    } else {
      setIsPreSignup(false);
    }
  };

  const handleRegisterSuccess = async () => {
    // let secondsToGo = 5;
    const instance =  modal.success({
      title: t("str_modal_success"),
      content: t("str_sign_up_success"),
      onOk() {
        handleLoginLink()
      },
      onCancel() {
        handleLoginLink()
      },
    });
    // setTimeout(() => {
    //   instance.destroy();
    //   // handleLoginLink({signup: true})
    // }, secondsToGo * 1000);
    // handleLoginLink({signup: true})
  };

  return (
    <div>
      {contextHolder}
      <div className="login-form-wrapper">
        <div className="login-form-container">
          <Flex paddingBottom={4} paddingTop={4} justifyContent="center">
            <Typography variant="alpha" style={{ textAlign: "center" }}>
              {t("str_register")}
            </Typography>
          </Flex>

          <Divider />

          <Box spacing={4} padding={8}>
            {isPreSignup && (
              <>
                <Box>
                  <div style={{ marginBottom: "15px" }}>
                    <Typography variant="delta" fontWeight="bold">
                      {t("str_nomination_role")}:
                    </Typography>
                    <br />
                    <br />
                    <Radio.Group
                      onChange={(e) => handleSetIsOrg(e.target.value)}
                      defaultValue={data.nominator.is_org_str}
                      value={data.nominator.is_org_str}
                    >
                      <Space direction="vertical" size={16}>
                        <Radio value="0">
                          {t("str_pre_register.nominator")}
                          {/* <Tooltip title={t("str_is_nominator")}>
                            <InfoCircleTwoTone style={{ marginLeft: "5px" }} />
                          </Tooltip> */}
                        </Radio>
                        <Radio value="1">
                          {t("str_pre_register.organization")}
                          {/* <Tooltip title={t("str_is_organization")}>
                            <InfoCircleTwoTone style={{ marginLeft: "5px" }} />
                          </Tooltip> */}
                        </Radio>
                        <Radio value="2">
                          {t("str_pre_register.nominee")}
                          {/* <Tooltip title={t("str_is_candidate")}>
                            <InfoCircleTwoTone style={{ marginLeft: "5px" }} />
                          </Tooltip> */}
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </div>

                  <Button htmlType="button" onClick={handleNextStep}>
                    <span>{t("str_continue")}</span>
                  </Button>
                </Box>
              </>
            )}
            {!isPreSignup && (
              <Form
                form={form}
                layout="vertical"
                name="basic"
                style={{
                  maxWidth: 600,
                }}
                onFinish={handleSubmit}
                autoComplete="off"
              >
                <Form.Item
                  label="Email"
                  name="email"
                  onChange={(e) => handleSetEmail(e.target.value)}
                  rules={[
                    {
                      required: true,
                      message: t("str_required_email"),
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (isValidEmail(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(t("str_email_invalid"))
                        );
                      },
                    }),
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label={t("str_password")}
                  name="password"
                  hasFeedback
                  onChange={(e) => handleSetPassword(e.target.value)}
                  rules={[
                    {
                      required: true,
                      message: t("str_required_password"),
                    },
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  name="confirm"
                  label={t("str_confirm_password")}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: t("str_please_confirm_password"),
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(t("str_password_not_match"))
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  name="full_name"
                  label={
                    data?.nominator?.is_org_str === "1"
                      ? t("str_name_of_organization")
                      : t("str_full_name")
                  }
                  onChange={(e) => handleSetName(e.target.value)}
                  rules={[
                    {
                      required: true,
                      message: t("str_required_full_name"),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                {data?.nominator?.is_org_str !== "1" && (
                  <Form.Item
                    name="pronouns"
                  >
                    <Radio.Group
                      onChange={onChangePronouns}
                      style={{ marginTop: "10px" }}
                      defaultValue="male"
                    >
                      <Radio value="male">{t("str_male")}</Radio>
                      <Radio value="female">{t("str_female")}</Radio>
                    </Radio.Group>
                  </Form.Item>
                )}
                

                <Form.Item
                  name="phone"
                  label={t("str_phone_number")}
                  onChange={(e) => handleSetPhone(e.target.value)}
                  rules={[
                    {
                      required: true,
                      message: t("str_required_phone_number"),
                    },
                    {
                      pattern:  /^\+?[0-9]{1,4}[-\s.]?(\(?[0-9]+\)?[-\s.]?){4,}$/,
                      message: t("str_phone_invalid"),
                    },
                  ]}
                >
                  <Input
                    // pattern="0[0-9]{9}"
                    maxLength={30}
                  />
                </Form.Item>

                {data?.nominator?.is_org_str !== "1" && (
                  <Form.Item
                    name="degree"
                    label={t("str_nominator_academic_rank_degree")}
                    rules={[
                      {
                        required: true,
                        message: t("str_required_academic_rank_and_degree"),
                      },
                    ]}
                  >
                    <DegreeSelect
                      lang={t("str_lang")}
                      value={data.nominator.degree}
                      onChange={handleSetDegree}
                    />
                  </Form.Item>
                )}

                <Form.Item {...tailLayout}>
                  <Button
                    htmlType="button"
                    onClick={() => setIsPreSignup(true)}
                  >
                    {t("str_back")}
                  </Button>
                  <Button
                    htmlType="submit"
                    type="primary"
                    style={{
                      margin: "0 8px",
                      textTransform: "uppercase",
                    }}
                    className="btnSave"
                  >
                    {t("str_register")}
                  </Button>
                </Form.Item>
              </Form>
            )}
            <br />

            <Stack spacing={4} horizontal>
              <TextButton onClick={handleForgotPassword}>
                {t("str_forget_password")}
              </TextButton>
              <TextButton onClick={handleLoginLink}>
                {t("str_login")}
              </TextButton>
            </Stack>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
